module.exports = __webpack_public_path__ + "static/OneDot-Bold.b5b545e1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Bold.woff2
// module id = 731
// module chunks = 114276838955818